import { Divider } from "@mui/material";
import React, { useLayoutEffect, useState } from "react";
import EmployeeInfoSection from "./EmployeeInfoSection/EmployeeInfoSection";
import { Props } from "./interfaces";
import RecieptsSection from "./RecieptsSection/RecieptsSection";
import { ExpenseReportContentContainer } from "./styles";
import { ER_ALERT_BY_LINK_ID } from "./utils";

const ExpenseReportContent = ({
  employee,
  handleChange,
  expenseReport,
  view,
  handleNotifyOnDocumentChange,
  changeDocCCCDStatus,
  handleNotifyParent,
  readOnly = false,
  wholeReportIsReadOnly,
  handleUpdateAuditActions,
  handleChangeAuditMutatedStatus,
  hideAuditNotes = false,
  isManagedByLink = false,
  preloadedFlags,
  forExport = false,
  currUserAuth,
  handleAddAuditorComment,
  allAuditNotes,
  handleUpdateExportAuditNotes,
}: Props) => {
  const [diffHeight, setDiffHeight] = useState<number>(0);

  useLayoutEffect(() => {
    const alertHeight = document.getElementById(`${ER_ALERT_BY_LINK_ID}`)?.clientHeight ?? 0;

    setDiffHeight(alertHeight);
  }, []);

  return (
    <ExpenseReportContentContainer
      container
      diffHeight={diffHeight}
      isManagedByLink={isManagedByLink}
      forExport={forExport}
    >
      <EmployeeInfoSection
        employee={employee}
        handleChange={handleChange}
        date={expenseReport.date}
        description={expenseReport.description}
        businessPurposeDescription={expenseReport.businessPurposeDescription}
        preApprovalDocument={expenseReport.preApprovalDocument}
        totalAmount={expenseReport.totalAmount ?? 0}
        legalEntity={expenseReport.legalEntity}
        currency={expenseReport.currency}
        view={view}
        handleNotifyOnDocumentChange={handleNotifyOnDocumentChange}
        changeDocCCCDStatus={changeDocCCCDStatus}
        readOnly={readOnly || wholeReportIsReadOnly}
        forExport={forExport}
        auditorComment={expenseReport.auditorComment}
        differenceAmount={expenseReport.travelExpenses
          .map((travelExp) => travelExp.difference)
          .reduce((prev, curr) => prev + curr, 0)}
        allTravelExpenseAudited={
          expenseReport.travelExpenses.filter((travelExpense) => travelExpense.auditAccepted === null).length === 0
        }
        status={expenseReport.status}
        handleAddAuditorComment={handleAddAuditorComment}
      />

      {!forExport && <Divider orientation="vertical" />}

      <RecieptsSection
        travelExpenses={expenseReport.travelExpenses}
        view={view}
        expenseReportStatusId={expenseReport.status?.id}
        handleChange={handleChange}
        employee={employee}
        handleNotifyParent={handleNotifyParent}
        readOnly={readOnly}
        wholeReportIsReadOnly={wholeReportIsReadOnly}
        handleUpdateAuditActions={handleUpdateAuditActions}
        handleChangeAuditMutatedStatus={handleChangeAuditMutatedStatus}
        hideAuditNotes={hideAuditNotes}
        customTableHeight={!!isManagedByLink}
        preloadedFlags={preloadedFlags}
        forExport={forExport}
        currUserAuth={currUserAuth}
        allAuditNotes={allAuditNotes}
        isManagedByLink={isManagedByLink}
        handleUpdateExportAuditNotes={handleUpdateExportAuditNotes}
      />
    </ExpenseReportContentContainer>
  );
};

export default ExpenseReportContent;
